import { createClient } from '@supabase/supabase-js';

// En producción/VPS, estas variables DEBEN estar definidas en el sistema o .env
const SUPABASE_URL = (import.meta as any).env?.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = () => {
    // Verificación estricta: No permitir valores por defecto vacíos o placeholders
    return !!SUPABASE_URL && 
           SUPABASE_URL.startsWith('https://') && 
           !!SUPABASE_ANON_KEY && 
           SUPABASE_ANON_KEY.length > 20;
};

// Crear cliente solo si hay configuración válida, si no, null (para evitar errores de red)
export const supabase = isSupabaseConfigured() 
    ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
        }
      })
    : null;

if (isSupabaseConfigured()) {
    console.debug("📡 Supabase: Cliente configurado con URL:", SUPABASE_URL);
} else {
    console.warn("⚠️ Supabase: No configurado. La app funcionará en modo 'Solo Local' (localStorage). Los datos se perderán si limpias el navegador o cambias de dispositivo.");
}

// Traduce el usuario que devuelve Supabase Auth al tipo User de la app.
// La identidad pasa a venir de la sesión firmada por Supabase, no de una constante del bundle.
export const usuarioDesdeSesion = (u: { id: string; email?: string | null; user_metadata?: Record<string, any> }) => {
    const email = u.email ?? '';
    const nombre = (u.user_metadata?.name as string | undefined) || email.split('@')[0] || 'Usuario';
    return {
        id: u.id,
        email,
        name: nombre,
        avatarUrl:
            (u.user_metadata?.avatar_url as string | undefined) ||
            `https://ui-avatars.com/api/?name=${encodeURIComponent(nombre)}&background=0ea5e9&color=fff`,
    };
};
